import CoveredParkingSvg from "@assets/images/svg/covered-parking.svg";
import React from "react";
import { View } from "react-native";

export interface CoveredParkingIconProps {
  size?: number;
  color?: string;
}

export function CoveredParkingIcon({
  size = 24,
  color = "#4D4D4D",
}: CoveredParkingIconProps) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CoveredParkingSvg width={size} height={size} color={color} />
    </View>
  );
}

export default CoveredParkingIcon;
